/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'view': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M915.456 790.601l97.865 97.792a36.571 36.571 0 01-51.785 51.785l-97.792-97.865a329.143 329.143 0 1151.712-51.712zM36.571 73.143h877.715a36.571 36.571 0 110 73.143H36.57a36.571 36.571 0 010-73.143zm0 365.714H256A36.571 36.571 0 01256 512H36.571a36.571 36.571 0 010-73.143zm0 365.714h256a36.571 36.571 0 110 73.143h-256a36.571 36.571 0 110-73.143zm621.715 36.572a256 256 0 100-512 256 256 0 000 512z"/>'
  }
})
